var render = function render(){var _vm=this,_c=_vm._self._c;return _c('omfy-button',{staticClass:"-ml-3 text-black-900 dark:text-slate-300",attrs:{"size":_vm.size,"variant":"clear","color-scheme":"secondary","icon":"list"},on:{"click":_vm.onMenuItemClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }